import {
  UserApi,
  UserModifyApi,
  ExportDataApi,
  ExcelApi,
  PayOrderNewApi,
  DownExcelPayController,
  ContractApi,
  ChargeConfigApi,
} from '@sayyoo/services-http-apis'
import { apiProxyUrl } from 'src/xhr/_config'
import { getCustomCookie } from 'src/xhr/_utils'

export function setURL() {
  UserApi.setHost(apiProxyUrl)
  UserModifyApi.setHost(apiProxyUrl)
  ExportDataApi.setHost(apiProxyUrl)
  ExcelApi.setHost(apiProxyUrl)
  PayOrderNewApi.setHost(apiProxyUrl)
  DownExcelPayController.setHost(apiProxyUrl)
  ContractApi.setHost(apiProxyUrl)
  ChargeConfigApi.setHost(apiProxyUrl)
}

export function applyToken() {
  UserModifyApi.applyHeaders({
    customCookie: getCustomCookie(),
  })
  ExportDataApi.applyHeaders({
    customCookie: getCustomCookie(),
  })
  ExcelApi.applyHeaders({
    customCookie: getCustomCookie(),
  })
  PayOrderNewApi.applyHeaders({
    customCookie: getCustomCookie(),
  })
  DownExcelPayController.applyHeaders({
    customCookie: getCustomCookie(),
  })
  ContractApi.applyHeaders({
    customCookie: getCustomCookie(),
  })
  ChargeConfigApi.applyHeaders({
    customCookie: getCustomCookie(),
  })
}

export function bootstrap() {
  setURL()
  applyToken()
}



// WEBPACK FOOTER //
// ./src/lib/http.js